import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import routeList from '../../routes/routeList';

const Project = ({ title, author, pic, excerpt, slug }) => {
  const picURL = pic !== 'false' ? pic : '/placeholders/project.png';
  return (
    <Link to={`${routeList.project}/${slug}`}>
      <div className="project-row mb-5">
        <Row className="text-body">
          <Col xs="12" md="4">
            <div className="project-thumbnail" style={{ backgroundImage: `url("${picURL}")` }} />
          </Col>
          <Col xs="12" md="7">
            <div className="project-info">
              <p className="subtitle-1 project-title mb-3" dangerouslySetInnerHTML={{ __html: title }} />
              <p>
                <strong>Autor</strong>
                <br />
                {author}
              </p>
              <p>
                <strong>O projekcie</strong>
                <br />
                {excerpt}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </Link>
  );
};

export default Project;
